export function replaceAccent(str) {
  const accents = 'àáâãäçèéêëìíîïñòóôõöùúûüýÿÀÁÂÃÄÇÈÉÊËÌÍÎÏÑÒÓÔÕÖÙÚÛÜÝ'
  const noAccents = 'aaaaaceeeeiiiinooooouuuuyyAAAAACEEEEIIIINOOOOOUUUUY'

  return str
    .split('')
    .map((char, idx) => (accents.includes(char) ? noAccents[accents.indexOf(char)] : char))
    .join('')
}
